// extracted by mini-css-extract-plugin
var _1 = "t2Ml";
var _2 = "t2Ml";
var _3 = "t2Md";
var _4 = "t2Mq";
var _5 = "t2Mc";
var _6 = "t2Mf";
var _7 = "t2Mk";
var _8 = "t2Mh";
var _9 = "t2Mo";
var _a = "t2Mm";
var _b = "t2Mn";
var _c = "t2Me";
var _d = "t2Mp";
var _e = "t2Mj";
var _f = "t2Mi";
export { _1 as "btn-link", _2 as "btnLink", _3 as "card", _4 as "comviq", _5 as "container", _6 as "content", _7 as "footer", _8 as "header", _9 as "image", _a as "loader", _b as "promotion", _c as "show", _d as "terms", _e as "text", _f as "title" }
